import { getDocumentGraphDataUpdatesInProgress, getShowedResultsSourceTaskIds, getSourceTasksResultsInProgress, actionCreators as graphActionCreators } from "Areas/Documents/graph";
import { Permissions, security } from "Common/permissions";
import { connect } from "react-redux";
import { progressOverlayStyle } from "../../Common";
import { getActiveDocumentId } from "../redux/getActiveDocumentId";
import TabTasks from "./tabTasks";
const mapStateToProps = (state) => ({
    inProgress: getSourceTasksResultsInProgress(state) || getDocumentGraphDataUpdatesInProgress(state),
    progressOverlayStyle,
    documentId: getActiveDocumentId(state),
    className: "pt-0_75 pb-0_5",
    showedResultsSourceTaskIds: getShowedResultsSourceTaskIds(state)
});
const canEditDocuments = security.isAllowed([Permissions.DocumentsEdit]);
const mapDispatchToProps = (dispatch) => canEditDocuments
    ? {
        onToggleShowHideResults: (documentId, sourceTaskIds, show) => {
            dispatch(graphActionCreators.toggleShowHideTaskResults(documentId, sourceTaskIds, show));
        }
    }
    : undefined;
export default connect(mapStateToProps, mapDispatchToProps)(TabTasks);
